module.exports = __webpack_public_path__ + "static/bane-s-contingency-e215952148b303b074a9481096ac9793.webp";